module.exports = __webpack_public_path__ + "assets/img/busy_8.cba09d4d.png";